export default {"src":"/_next/static/media/person.2d830578.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};